import cookieUtil from 'tradera-utils/cookie';

var searchId = (function() {
    let cookieName = 's';

    function removeSearchId() {
        searchId.cookieUtil.eraseCookie(cookieName);
    }

    function saveSearchId(value) {
        let date = new Date();
        date.setMonth(date.getMonth() + 1);
        searchId.cookieUtil.createCookie(cookieName, value, date);
    }

    return {
        remove: function() {
            removeSearchId();
        },
        set: function(name, value) {
            saveSearchId(name, value);
        }
    };
})();

searchId.cookieUtil = cookieUtil;

export default searchId;
